<template>
  <span class="quiz_release_date">公開日 {{dateTime}}</span>
</template>

<script>
import Util from '@/modules/Util'

export default {
  name: 'QuizReleaseDate',
  props: {
    timestamp: {
      type: String,
      required: true
    }
  },
  computed: {
    dateTime () {
      return Util.getDateTime(this.timestamp)
    }
  }
}
</script>

<style scoped>
  .quiz_release_date {
    font-size: 20px;
    position: absolute;
    right: 40px;
    bottom: 20px;
  }
  @media screen and (max-width: 767px) {
    .quiz_release_date {
      right: 3%;
      bottom: -30px;
      color: #ec8dae;
    }
  }

</style>
